import type { Step } from 'types/Step';
import type { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';
import { LoginStep } from 'components/Login/Steps';

type Direction = keyof Pick<LoginStep, 'next' | 'previous' >;

export function getFollowingStep<T extends Step<unknown, unknown>>(
  currentStep: T,
  steps: Array<T>,
  reference: Array<T>,
  direction: Direction = 'next',
): SelfServiceSteps {
  if (steps.some(({ key }) => key === currentStep[direction])) {
    return currentStep[direction];
  }

  const followingStep = reference.find(({ key }) => key === currentStep[direction]);
  if (followingStep) {
    return getFollowingStep(followingStep, steps, reference, direction);
  }

  return undefined;
}
